export const EXISTING_JOB_DISABLE_REASON =
  'Candidate already added to this job';

interface JobOption {
  value?: number | string;
  isDisabled?: boolean;
  disableReason?: string;
  [key: string]: unknown;
}

// Grey out (and block selecting) any job the candidate is already in. Applied
// at render time from the LIVE `existingJobIds` — not from the value baked into
// each option when it was fetched. react-select caches the default (pre-search)
// option list, and that list is fetched on mount while `existingJobIds` is
// still empty (contactData hasn't resolved), so the baked flag is stale there.
// Re-deriving here keeps the default list correctly disabled, matching search
// (ENG-3497).
export const applyExistingJobExclusion = (
  options: JobOption[] = [],
  existingJobIds: Array<number | string> = []
): JobOption[] =>
  options.map((option) =>
    existingJobIds.includes(option?.value as number | string)
      ? {
          ...option,
          isDisabled: true,
          disableReason: EXISTING_JOB_DISABLE_REASON,
        }
      : option
  );
